import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  propertyValue: "1000000",
  timePeriod: "1",
  interestRate: "12",
  propertyType: "residential",
  employmentType: "salaried",
  monthlyEmi: 0,
  calculationResults: null
};

const ltvSlice = createSlice({
  name: "ltvCalculator",
  initialState: initialState,
  reducers: {
    setPropertyValue: (state, action) => {
      state.propertyValue = action.payload;
    },
    setTimePeriod: (state, action) => {
      state.timePeriod = action.payload;
    },
    setInterestRate: (state, action) => {
      state.interestRate = action.payload;
    },
    setPropertyType: (state, action) => {
      state.propertyType = action.payload;
    },
    setEmploymentType: (state, action) => {
      state.employmentType = action.payload;
    },
    setMonthlyEmi: (state, action) => {
      state.monthlyEmi = action.payload;
    },
    setCalculationResults: (state, action) => {
      state.calculationResults = action.payload;
    },
    resetLtvData: (state) => {
      return initialState;
    },
  },
});

export const {
  setPropertyValue, setTimePeriod, setInterestRate, setPropertyType, setEmploymentType, setMonthlyEmi, setCalculationResults, resetLtvData
} = ltvSlice.actions;

export default ltvSlice.reducer;